import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'OPZPage',
  props: {
    // 是否为分页按钮添加背景色
    background: {
      type: Boolean,
      default: true
    },
    // 每页显示条目个数，支持 .sync 修饰符
    pageSize: {
      type: Number,
      default: 10
    },
    // 总条目数
    total: {
      type: Number,
      default: 0
    },
    // 总页数
    pageCount: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {};
  },
  methods: {
    handleSizeChange: function handleSizeChange(size) {
      this.$emit('size-change', size);
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.$emit('current-change', page);
    }
  }
};